import { isClientSide } from '@dce-front/onewebapp-utils';
import type { InitParameters } from '@dce-front/sdk-hodor';
import { getPublicConfig } from '../../../helpers/config/config-helper';

export const getSdkInitParameters = (): InitParameters => {
  const {
    api: {
      hodor: { initParameters },
    },
  } = getPublicConfig();

  const { allowedProfiles, featureToggles, ...rest } = initParameters;

  if (!isClientSide()) {
    return { featureToggles, ...rest };
  }

  return {
    allowedProfiles,
    featureToggles,
    ...rest,
  };
};
